import { JOB_SERVER_URL } from "../../config";
import http from "../../net/http-common";

export const getGenieProperties = (task_id: string) => {
  const params = {
    task_id: task_id,
    as_file: false,
  };
  return http.get(`${JOB_SERVER_URL}/maimol_pipeline/results/genie`, {
    params,
    headers: {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });
};
